export const ADD_EVENTS = "ADD_EVENTS";
export const UPDATE_EVENTS = "UPDATE_EVENTS";
export const DELETE_EVENTS = "DELETE_EVENTS";
export const SET_EVENTS = "SET_EVENTS";
export const CHANGE_STATUS = "CHANGE_STATUS";
export const SET_FREE_CLASSES = "SET_FREE_CLASSES";
export const DELETE_FREE_CLASSES = "DELETE_FREE_CLASSES";
export const CHANGE_FREE_CLASS_STATUS = "CHANGE_FREE_CLASS_STATUS";
